import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiQuizListComponent } from './fi-quiz-list.component';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatCard, MatCardContent, MatCardModule } from '@angular/material/card';
import { MatCell } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiEmptyListModule } from '@fi-shared/fi-empty-list/fi-empty-list.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';

@NgModule({
    imports: [
        CommonModule,
        FiItemsListModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        MatButtonModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatMenuModule,
        MatSortModule,
        FiWhenScrolledModule,
        FiEmptyListModule,
        FiLoadingModule,
    ],
    declarations: [FiQuizListComponent],
})
export class FiQuizListModule {}
